import { gql, useQuery } from "@apollo/client";
import {
  AvailableSolutionMembersRoles,
  AvailableSolutionMembersRolesVariables
} from "./schema/AvailableSolutionMembersRoles";
import { Members, MembersVariables } from "./schema/Members";

export const membersList = gql`
  query Members($solutionKey: Key!) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        access {
          users {
            firstName
            roles
            lastName
            name
            permissions
          }
        }
      }
    }
  }
`;

export const availableRolesList = gql`
  query AvailableSolutionMembersRoles($solutionKey: Key!) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        access {
          availableRoles
        }
      }
    }
  }
`;

export const useQueryGetMembers = (solutionKey: string) =>
  useQuery<Members, MembersVariables>(membersList, {
    variables: { solutionKey }
  });

export const useQueryGetAvailableRoles = (solutionKey: string) =>
  useQuery<
    AvailableSolutionMembersRoles,
    AvailableSolutionMembersRolesVariables
  >(availableRolesList, {
    variables: { solutionKey }
  });
